import * as React from 'react';

import cl from 'classnames';
import s from './LinkCard.module.css';
import NewsArrow from '../FerrariIcon/NewsArrow';

export default function LinkCard(props) {
  function enterKeyEvent(event) {
    event.key === 'Enter' ? startTest(tests) : null;
  }

  const {category, title, description, img, link} = props;

  return (
    <div
      className={s.FerrariTestCardContainer}
      tabIndex={0}
      onKeyPress={e => enterKeyEvent(e)}
      aria-label="Open Link"
    >
      <img className={s.TestCardImg} src={img} alt="" />
      <div className={s.TestInfo}>
        <div className={s.TestNumber}>{category}</div>
        <div className={s.TestName}>{title}</div>
        <p className={s.TestDescript}>{description}</p>
        <div className={s.Read}>
          <NewsArrow color="red" />{' '}
          <a href={link} target="_blank" className={s.ReadMoreButton}>
            Read More...
          </a>
        </div>
      </div>
    </div>
  );
}
